import { NextContentfulImage } from "@components/Image";
import { SiteSettings } from "@customTypes/SiteSettings";
import { useId, useState } from "react";
import ShareSvg from "../../../public/image/svg/share.svg";
import { Results } from "../CoveoSearchComponent";
import { getTopicIdAndName } from "../coveoUtils";

interface NewsDetailsResultsTemplateProps {
  siteSettings?: SiteSettings;
  result: Results;
  handleSelect?: () => void;
}

export const NewsDetailsResultsTemplate = (
  props: NewsDetailsResultsTemplateProps
) => {
  const { result, siteSettings } = props;
  const [open, setOpen] = useState(false);

  const replace = (shareLink) =>
    shareLink?.replace("%URL%", encodeURIComponent(result.clickUri));

  const dateString = result?.raw?.articledatetext || "";
  const id = useId();
  const titleId = `bsr-title-${id}`;

  return (
    <article>
      <div>
        {result?.raw?.articleimageurl &&
          !result?.raw?.articleimageurl.includes("undefined") && (
            <div className="wrapperImage">
              <a className="imageLink" href={result.clickUri} onClick={props.handleSelect}>
                <NextContentfulImage
                  src={result.raw.articleimageurl}
                  alt=""
                  width={896}
                  height={504}
                  loading="eager"
                  sizes="(max-width: 768px) 100vw, 20vw"
                />
              </a>
            </div>
          )}
        <div className="text1">
          <p className="primary-tag">NEWS</p>
          <h2 id={titleId} className="h3">
            <a className="coveo-link" href={result.clickUri} onClick={props.handleSelect}>
              {result?.raw?.newstitle}
            </a>
          </h2>
          <p className="sub-heading medium-light">{dateString}</p>
          <p
            className="CoveoFieldValue copy medium-light"
            data-field="@shortdescription"
          >
            <span>{result.raw.pagedescription}</span>
          </p>
          {result.raw.articleauthorsnames && (
            <p
              className="CoveoFieldValue info-field"
              data-field="@articleauthorsnames"
            >
              By
              <span className="authors">
                {result?.raw?.articleauthorsnames
                  .map((author) => author)
                  .join(", ")}
              </span>
            </p>
          )}
          <div className="card-footer" role="group" aria-labelledby={titleId}>
            {result.raw.taz120xonomytopics?.map((topic, i) => {
              const [id, name] = getTopicIdAndName(topic);
              return (
                <div key={`${name}-${i}`} className="component tag cf">
                  <a href={`/news?${id}=${name}`}>{name}</a>
                </div>
              );
            })}
            <div className={`social-share ${open && "show"}`}>
              <button
                className="share-toggle"
                aria-label="Share content"
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(!open);
                }}
              >
                <span className="visually-hidden">Share</span>
                <i
                  className="icon-share"
                  data-grunticon-embed="data-grunticon-embed"
                >
                  <ShareSvg />
                </i>
              </button>
              <ul className="share-links">
                {siteSettings &&
                  siteSettings?.globalSocialShareCollection.map(
                    ({ fields: { name, darkIcon, shareLink } }, index) => (
                      <li key={`${name}-${index}`}>
                        <a
                          aria-label={`${name} - Opens a new window`}
                          href={replace(shareLink)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <NextContentfulImage
                            src={darkIcon.url}
                            alt={name}
                            width={30}
                            height={30}
                          />
                        </a>
                      </li>
                    )
                  )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default NewsDetailsResultsTemplate;
